<template>
    <div class="container-fluid m-2">
        <div class="snackbars">
            <div class="container">
                <div class="row justify-content-center">
                    <snackbar type="success" v-if="showNotification" v-on:close="closeNotification">
                        La décision a été envoyée par email à l'entreprise.
                    </snackbar>
                    <snackbar type="success" v-if="showNotificationWaiting" v-on:close="closeNotification">
                        La facture été envoyée par email à l'entreprise.
                    </snackbar>
                </div>
            </div>
        </div>

        <!-- Validation Notification Modal -->
        <Modal ref="modal__validate_notification" size="modal--normal">
            <div slot="content" class="p-4">
                <h2 class="mb-3">Validation de l'inscription</h2>
                <p class="mb-4">Souhaitez-vous envoyer une notification à l'entreprise ?</p>

                <div class="form-group">
                    <label class="d-block mb-2">
                        <input type="radio" v-model="notificationMode" value="standard" class="mr-2">
                        Oui (notification standard)
                    </label>
                    <label class="d-block mb-2">
                        <input type="radio" v-model="notificationMode" value="none" class="mr-2">
                        Non (pas de notification)
                    </label>
                    <label class="d-block mb-2">
                        <input type="radio" v-model="notificationMode" value="custom" class="mr-2">
                        Écrire un message personnalisé
                    </label>
                </div>

                <div v-if="notificationMode === 'custom'" class="mt-4">
                    <div class="form-group">
                        <label class="form-label">Sujet</label>
                        <input type="text" v-model="customSubject" class="form-control">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Salutation</label>
                        <input type="text" v-model="customGreeting" class="form-control">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Contenu</label>
                        <vue-editor v-model="customContent" :editorToolbar="editorToolbar"></vue-editor>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Formule de politesse</label>
                        <input type="text" v-model="customSalutation" class="form-control">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Signature</label>
                        <vue-editor v-model="customSignature" :editorToolbar="editorToolbar"></vue-editor>
                    </div>
                </div>

                <div class="btn-group mt-4">
                    <button @click="confirmValidate" class="btn-green mr-2" :disabled="isValidating">
                        <span v-if="isValidating">Validation en cours...</span>
                        <span v-else>Valider</span>
                    </button>
                    <button @click="closeValidateModal" class="btn--underline">Annuler</button>
                </div>
            </div>
        </Modal>

        <div class="row">
            <aside class="col-4 mt-4">
                <div class="section p-0 validations">
                    <div class="tabs">
                        <div class="tab pointer" :class="{ 'is-active' : !coveredMode }" @click="toggleMode">
                            <span>Demandes d'inscription </span><span
                            class="badge badge--orange">{{ allCompanies ? allCompanies.length : 0 }}</span>
                        </div>
                        <div class="tab pointer" :class="{ 'is-active' : coveredMode }" @click="toggleMode">
                            <span>Entreprises a valider </span><span
                            class="badge badge--orange">{{ coveredCompanies ? coveredCompanies.length : 0 }}</span>
                        </div>
                    </div>

                    <div v-if="coveredMode">
                        <h3 class="p-3">Entreprises a valider</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="company in coveredCompanies"
                            :key="company.id"
                            v-if="coveredCompanies.length > 0"
                            @click="setSelectedCompany(company, true)">
                            <div class="listitem__name">
                                {{ company.name }}
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h3 class="p-3">Demandes d'inscription</h3>
                        <div
                            class="listitem pointer validations"
                            v-for="company in allCompanies"
                            :key="company.id"
                            v-if="allCompanies.length > 0"
                            @click="setSelectedCompany(company, false)">
                            <div class="listitem__name">
                                {{ company.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
            <div class="col-8">
                <div v-if="selectedCompany">
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button @click="previous" type="button" class="btn-dark-grey" :disabled='!hasPrevious'>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" @click="postWaiting" v-if="!coveredMode">
                                Envoyer facture
                            </button>
                            <button type="button" class="btn-dark-grey" @click="openValidateModal" v-if="coveredMode">
                                Valider
                            </button>

                            <button @click="next" type="button" class="btn-dark-grey" :disabled='!hasNext'>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <div class="row" v-if="!coveredMode">
                            <div class="col-12">
                                <div class="section__infos mb-3">
                                    <svg viewBox="0 0 24 24">
                                        <use xlink:href="#information"></use>
                                    </svg>
                                    La facture est envoyée automatiquement par email à l'entreprise. L'entreprise est ensuite en attente de validation.
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-2">
                                <div class="profileOverview__pic avatar avatar--large mb-4">
                                    <img v-if="selectedCompany.picture_url"
                                         :src="selectedCompany.picture_url"
                                         alt="" class="avatar__default">
                                </div>
                                <a :href="selectedCompany.view_url" class="btn-medium-grey" target="_blank">
                                    Voir profil
                                </a>
                            </div>
                            <div class="col-10">
                                <div class="profileOverview__infos">
                                    <h2 class="profileOverview__name">{{ selectedCompany.name }}</h2>

                                    <h3 class="mb-0">Demande d'inscription le</h3>
                                    <span class="profileOverview__name">{{ selectedCompany.sub_date }}</span>

                                    <h3 class="mb-0">Dernière mise à jour du profil</h3>
                                    <span class="profileOverview__name">{{ selectedCompany.profil_update }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-2">
                                <h3>Participation aux éditions précédentes</h3>
                                <ul v-if="selectedCompany.subscriptions.length > 0" style="margin: 0">
                                    <li v-for="sub in selectedCompany.subscriptions">{{ sub.edition.name }}</li>
                                </ul>
                                <p v-else>Première édition</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="actionsBar actionBar--normalMargin  mt-3 mb-3">
                        <div class="ml-auto">
                            <button type="button" class="btn-dark-grey" disabled>
                                Précédent
                            </button>
                            <button type="button" class="btn-dark-grey" disabled>
                                Suivant
                            </button>
                        </div>
                    </div>
                    <div class="section mt-4">
                        <p>Aucune demande d'inscription a valider</p>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import moment from "moment";
import Snackbar from "../AppNotifications/Snackbar";
import Modal from "../layout/Modal";
import { VueEditor } from 'vue2-editor';

export default {
    components: {
        Snackbar,
        Modal,
        VueEditor
    },
    props: {
        companies: Array,
        waitingValidationCompanies: Array,
        routeWaiting: String,
        routeValidate: String,
        routeDefaultMessage: String,
        labels: Array,
        waitingStatus: String,
        icEcoTax: String,
        labelEcoTax: String
    },
    data: function () {
        return {
            selectedCompany: null,
            allCompanies: this.companies,
            coveredCompanies: this.waitingValidationCompanies,
            index: 0,
            indexCovered: 0,
            coveredMode: false,
            showNotification: false,
            showNotificationWaiting: false,
            // Modal-related data
            notificationMode: 'standard',
            customSubject: '',
            customGreeting: '',
            customContent: '',
            customSalutation: '',
            customSignature: '',
            isValidating: false,
            editorToolbar: [
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }]
            ]
        }
    },
    methods: {
        closeNotification(event) {
            this.showNotification = !event
        },
        format(birthDay) {
            return moment(birthDay).format('L')
        },
        toggleMode() {
            this.coveredMode = !this.coveredMode
            if (this.coveredMode) {
                this.selectedCompany = this.coveredCompanies[this.indexCovered]
            } else {
                this.selectedCompany = this.allCompanies[this.index]
            }
        },
        postWaiting() {
            if (this.routeWaiting) {
                axios.post(this.routeWaiting, {
                        'item': this.selectedCompany.pivot.id
                    }
                ).then((response) => {
                    this.coveredCompanies.push(this.selectedCompany)
                    this.allCompanies.splice(this.index, 1)
                    if (this.allCompanies.length > 0) {
                        if (this.index === this.allCompanies.length) {
                            this.index--
                        }
                        this.selectedCompany = this.allCompanies[this.index]
                    } else {
                        this.selectedCompany = null
                        this.index = 0
                    }
                    this.showNotificationWaiting = true
                }).catch(function (error) {
                    // error management?
                    console.log(error);
                });
            }
        },
        openValidateModal() {
            // Reset modal data
            this.notificationMode = 'standard';
            this.isValidating = false;

            // Load default message content
            if (this.routeDefaultMessage && this.selectedCompany) {
                const lang = this.selectedCompany.address ? this.selectedCompany.address.communication_language : 'fr';
                axios.get(this.routeDefaultMessage, { params: { lang: lang } })
                    .then(response => {
                        this.customSubject = response.data.subject;
                        this.customGreeting = response.data.greeting;
                        this.customContent = response.data.content;
                        this.customSalutation = response.data.salutation;
                        this.customSignature = response.data.signature;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }

            this.$refs['modal__validate_notification'].toggleModal();
        },
        closeValidateModal() {
            this.$refs['modal__validate_notification'].toggleModal();
        },
        confirmValidate() {
            if (!this.routeValidate || this.isValidating) {
                return;
            }

            this.isValidating = true;

            const payload = {
                'item': this.selectedCompany.pivot.id,
                'notification_mode': this.notificationMode
            };

            if (this.notificationMode === 'custom') {
                payload.custom_subject = this.customSubject;
                payload.custom_greeting = this.customGreeting;
                payload.custom_content = this.customContent;
                payload.custom_salutation = this.customSalutation;
                payload.custom_signature = this.customSignature;
            }

            axios.post(this.routeValidate, payload)
                .then((response) => {
                    // Close modal
                    this.closeValidateModal();

                    // Show notification based on mode
                    if (this.notificationMode !== 'none') {
                        this.showNotification = true;
                    }

                    // Update lists
                    if (this.coveredMode) {
                        this.coveredCompanies.splice(this.indexCovered, 1)
                        if (this.coveredCompanies.length > 0) {
                            if (this.indexCovered === this.coveredCompanies.length) {
                                this.indexCovered--
                            }
                            this.selectedCompany = this.coveredCompanies[this.indexCovered]
                        } else {
                            this.selectedCompany = null
                            this.indexCovered = 0
                        }
                    } else {
                        this.allCompanies.splice(this.index, 1)
                        if (this.allCompanies.length > 0) {
                            if (this.index === this.allCompanies.length) {
                                this.index--
                            }
                            this.selectedCompany = this.allCompanies[this.index]
                        } else {
                            this.selectedCompany = null
                            this.index = 0
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isValidating = false;
                });
        },
        previous() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0) {
                    if (this.indexCovered > 0) {
                        this.indexCovered--
                        this.selectedCompany = this.coveredCompanies[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            } else {
                if (this.allCompanies.length > 0) {
                    if (this.index > 0) {
                        this.index--
                        this.selectedCompany = this.allCompanies[this.index]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            }
        },

        next() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0) {
                    if (this.indexCovered < this.coveredCompanies.length - 1) {
                        this.indexCovered++
                        this.selectedCompany = this.coveredCompanies[this.indexCovered]
                    }
                } else {
                    this.indexCovered = 0;
                    this.selectedCompany = null
                }
            } else {
                if (this.allCompanies.length > 0) {
                    if (this.index < this.allCompanies.length - 1) {
                        this.index++
                        this.selectedCompany = this.allCompanies[this.index]
                    }
                } else {
                    this.index = 0;
                    this.selectedCompany = null
                }
            }

        },
        setSelectedCompany(toDisplayCompany, mode) {
            this.coveredMode = mode
            if (this.coveredMode) {
                let newIndex = this.coveredCompanies.findIndex(company => company.id === toDisplayCompany.id)
                if (newIndex > -1) {
                    this.indexCovered = newIndex
                    this.selectedCompany = this.coveredCompanies[newIndex]
                }
            } else {
                let newIndex = this.allCompanies.findIndex(company => company.id === toDisplayCompany.id)
                if (newIndex > -1) {
                    this.index = newIndex
                    this.selectedCompany = this.allCompanies[newIndex]
                }
            }
        }
    },
    beforeMount() {
        if (this.allCompanies.length > 0) {
            this.selectedCompany = this.allCompanies[this.index]
        }
    },
    mounted() {

    },
    computed: {
        hasPrevious() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0 && this.indexCovered > 0) {
                    return true
                }
            } else {
                if (this.allCompanies.length > 0 && this.index > 0) {
                    return true
                }
            }
            return false
        },
        hasNext() {
            if (this.coveredMode) {
                if (this.coveredCompanies.length > 0 && this.indexCovered < this.coveredCompanies.length - 1) {
                    return true
                }
            } else {
                if (this.allCompanies.length > 0 && this.index < this.allCompanies.length - 1) {
                    return true
                }
            }
            return false
        }
    }
};
</script>
